import { API_ORIGIN } from '@/constants'

export type LinkedInShareStatus = {
  enabled: boolean
  connected: boolean
  token_valid: boolean
}

export async function fetchLinkedInShareStatus(token: string): Promise<LinkedInShareStatus> {
  const response = await fetch(`${API_ORIGIN}/api/accounts/linkedin/share/status`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok) {
    throw new Error('Failed to load LinkedIn share status')
  }
  return (await response.json()) as LinkedInShareStatus
}

export async function startLinkedInShareConnect(token: string, returnTo: string): Promise<string> {
  const response = await fetch(`${API_ORIGIN}/api/accounts/linkedin/share/connect`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ return_to: returnTo }),
  })
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { error?: string }
    throw new Error(body.error ?? 'Failed to start LinkedIn connection')
  }
  const data = (await response.json()) as { authorize_url?: string }
  if (!data.authorize_url) {
    throw new Error('Missing LinkedIn authorize URL')
  }
  return data.authorize_url
}

export async function postJobToLinkedIn(args: {
  token: string
  opportunityId: string
  caption: string
}): Promise<{ post_id: string; share_url: string }> {
  const response = await fetch(`${API_ORIGIN}/api/accounts/linkedin/share/post`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${args.token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      opportunity_id: args.opportunityId,
      caption: args.caption,
    }),
  })
  const body = (await response.json().catch(() => ({}))) as {
    error?: string
    post_id?: string
    share_url?: string
  }
  if (!response.ok) {
    throw new Error(body.error ?? 'Failed to post to LinkedIn')
  }
  return {
    post_id: body.post_id ?? '',
    share_url: body.share_url ?? '',
  }
}

export function defaultLinkedInShareCaption(args: {
  title: string
  organisationName: string
  shareUrl: string
}): string {
  return `We're hiring: ${args.title} at ${args.organisationName}. Apply: ${args.shareUrl}`
}
